/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "dollar--sprite",
  "use": "dollar--sprite-usage",
  "viewBox": "0 0 23 38",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 38\" id=\"dollar--sprite\"><path d=\"M9.008 37.6v-4.4a23.038 23.038 0 0 1-4.96-1C2.5 31.693 1.18 31.013.088 30.16l1.76-4.88c1.226.88 2.613 1.573 4.16 2.08 1.546.507 3.173.76 4.88.76 1.813 0 3.107-.293 3.88-.88.8-.587 1.2-1.307 1.2-2.16 0-.747-.267-1.36-.8-1.84-.534-.48-1.493-.867-2.88-1.16l-4.4-.96c-4.854-1.067-7.28-3.653-7.28-7.76 0-2.24.76-4.133 2.28-5.68 1.52-1.547 3.56-2.52 6.12-2.92V.2h4.76v4.48c1.413.16 2.76.493 4.04 1 1.28.507 2.36 1.187 3.24 2.04l-1.76 4.56c-2-1.733-4.56-2.6-7.68-2.6-1.52 0-2.734.32-3.64.96-.88.64-1.32 1.467-1.32 2.48 0 .747.266 1.347.8 1.8.533.453 1.44.827 2.72 1.12l4.36.96c5.013 1.093 7.52 3.627 7.52 7.6 0 2.267-.773 4.133-2.32 5.6-1.52 1.467-3.507 2.413-5.96 2.84v4.56h-4.76Z\" fill=\"#232323\" /></symbol>"
});
sprite.add(symbol);
var viewBoxValues = symbol.viewBox ? symbol.viewBox.split(' ') : []

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox,
      width: viewBoxValues[2],
      height: viewBoxValues[3]
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.width = viewBoxValues[2];
SvgSpriteIcon.height = viewBoxValues[3];
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
